import { AllForms } from "../../utils/functionsInterfaces";
import { displayError, displayWarning } from "../../utils/messageToast";
import { SetupAuth } from "../../client";

export const getFormByIdItemId = async (
  clientId: string,
  search: string,
  ambient: string,
  setAllForm: React.Dispatch<React.SetStateAction<AllForms[]>>,
  setSearch: React.Dispatch<React.SetStateAction<string>>,
  token: string,
) => {
  try {
    const apiClient = SetupAuth(token);
    const response = await apiClient.post(`/get-form`, {
      clientId,
      alias: search,
      ambient,
    });
    setAllForm([response.data.form]);
  } catch (error: any) {
    if (error.response.status === 404) {
      displayWarning("Formulário não encontrado!");
      setSearch("");
    } else if (error.response.status === 401) {
      displayWarning("Você não tem permissão para acessar este formulário!");
      setSearch("");
    } else {
      displayError("Erro ao buscar formulário!");
      setSearch("");
    }
  }
};
